import { CloudOutlined } from '@ant-design/icons';
import { Platform, findAllPlatform } from '../../apis/mgmt/api';
import { DataOptionProps, DataSelect, DataFormItem, DataSelectFormItemProps, DataSelectProps, ValueFormItemProps } from '../common/DataSelect';
import { omit } from '../../utils/PropsUtils';
import { FormItemProps } from 'antd';


export const PlatformOptionProps: DataOptionProps<Platform> = {
  valueFromData: (data) => data?.id,
  labelFromData: (data) => data?.name,
}

const defaultSearch = async (newValue: string) => {
    const result = await findAllPlatform({ size: 10 });
    return result.data.content || [];
}

export const PlatformSelect = function<TFilter>(props: DataSelectProps<Platform,TFilter>) {
    return (
        <DataSelect<Platform,TFilter>
            placeholder="Platform"
            suffixIcon={<CloudOutlined className="site-form-item-icon" />}
            dataOptionsProps={PlatformOptionProps}
            {...props}
            search={props.search || defaultSearch}
        />
    );
}

export const PlatformFormItem = (props: FormItemProps<any>) => 
    <DataFormItem<Platform>
        {...props}
        dataOptionsProps={PlatformOptionProps}
    />
;
